import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=64fcfda3&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"
import style0 from "./SearchForm.scss?vue&type=style&index=0&id=64fcfda3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcfda3",
  null
  
)

export default component.exports